import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="bg-cream py-16 md:py-24" aria-labelledby="testimonials-heading" data-id="element-504">
      <div className="max-w-5xl mx-auto px-4" data-id="element-505">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-506">
          <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4" data-id="element-507">
            Real Women. Real Results.
          </p>
          <h2 id="testimonials-heading" className="font-serif text-forest text-3xl md:text-4xl font-700 leading-tight" data-id="element-508">
            What Happens When You Stop Fighting Your Biology
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-509">
          <motion.article initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-2xl p-7 shadow-sm border border-sage/20 flex flex-col" data-id="element-510">
            <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars" data-id="element-511">
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-512" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-513" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-514" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-515" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-516" />
            </div>
            <blockquote className="font-sans text-stone-700 text-base leading-relaxed italic flex-1 mb-5" data-id="element-517">
              "I lost 2 inches off my waist in the first 3 weeks — without
              giving up a single meal I loved. I just changed WHEN I ate them."
            </blockquote>
            <footer className="font-sans" data-id="element-518">
              <p className="font-700 text-forest text-sm" data-id="element-519">Margaret T., 58</p>
              <p className="text-stone-400 text-xs" data-id="element-520">Arizona</p>
            </footer>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl p-7 shadow-sm border border-sage/20 flex flex-col" data-id="element-521">
            <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars" data-id="element-522">
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-523" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-524" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-525" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-526" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-527" />
            </div>
            <blockquote className="font-sans text-stone-700 text-base leading-relaxed italic flex-1 mb-5" data-id="element-528">
              "I haven't slept through the night in 4 years. After week 2 of the
              evening protocol, I slept 7 hours straight. The bloating is almost
              gone."
            </blockquote>
            <footer className="font-sans" data-id="element-529">
              <p className="font-700 text-forest text-sm" data-id="element-530">Susan K., 63</p>
              <p className="text-stone-400 text-xs" data-id="element-531">Florida</p>
            </footer>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white rounded-2xl p-7 shadow-sm border border-sage/20 flex flex-col" data-id="element-532">
            <div className="flex gap-0.5 mb-4" aria-label="5 out of 5 stars" data-id="element-533">
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-534" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-535" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-536" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-537" />
              <StarIcon className="w-4 h-4 fill-terracotta text-terracotta" data-id="element-538" />
            </div>
            <blockquote className="font-sans text-stone-700 text-base leading-relaxed italic flex-1 mb-5" data-id="element-539">
              "My doctor told me my inflammation markers dropped significantly.
              I told her it was the salmon salad. She didn't believe me until
              she saw the protocol."
            </blockquote>
            <footer className="font-sans" data-id="element-540">
              <p className="font-700 text-forest text-sm" data-id="element-541">Linda R., 61</p>
              <p className="text-stone-400 text-xs" data-id="element-542">Ohio</p>
            </footer>
          </motion.article>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center font-sans text-stone-400 text-xs mt-6" data-id="element-543">
          *Results may vary. Testimonials represent individual experiences.
        </motion.p>
      </div>
    </section>;
}